import React from 'react';
import PropTypes from 'prop-types';
import Locale from '../locales/en/navBar';

const MobileNavBarBottom = ({ navLocation }) => {
  const renderPillars = () => (
    Locale.pillars.map((pillar, idx) => (
      <a
        key={pillar.key}
        href={`#${pillar.key}`}
        className={navLocation === (idx + 1) ? 'selected' : ''}
      >
        {idx + 1}
      </a>
    ))
  );

  return (
    <div className="mobile-nav-bar-bottom">
      <div className="nav-links">
        {renderPillars()}
      </div>
    </div>
  );
};

MobileNavBarBottom.propTypes = {
  navLocation: PropTypes.number
};

MobileNavBarBottom.defaultProps = {
  navLocation: null
};

export default MobileNavBarBottom;
